import { Aggregator } from '@liberty-financial/agp-shared';

import { Claims } from '@core/authentication/claims';
import { environment } from '@env/environment';

import {
  AggregatorFeatureFlag,
  IAggregatorConfiguration
} from './aggregator.interface';

export const aggregator: IAggregatorConfiguration = {
  name: Aggregator.LNS,
  features: {
    [AggregatorFeatureFlag.ProductMatrix]: true,
    [AggregatorFeatureFlag.ManualRefix]: false,
    [AggregatorFeatureFlag.RefixReport]: false,
    [AggregatorFeatureFlag.Reports]: true,
    [AggregatorFeatureFlag.DeleteDiaryNote]: true,
    [AggregatorFeatureFlag.Events]: false,
    [AggregatorFeatureFlag.ContactsReport]: true,
    [AggregatorFeatureFlag.OpportunitiesReport]: true,
    [AggregatorFeatureFlag.CanvasMetricsReport]: true,
    [AggregatorFeatureFlag.Calculators]: true,
    [AggregatorFeatureFlag.AppInsights]: true,
    [AggregatorFeatureFlag.AliGroupInsurance]: true,
    [AggregatorFeatureFlag.Reverse]: true,
  },
  settings: {
    claims: {
      defaults: {
        country: Claims.Country.Australia
      }
    },
    auth: {
      domain: environment.production
        ? 'authentication.sparkplus.liberty.com.au'
        : 'authentication.sparkplus.sandbox-liberty.com.au'
    }
  }
};
